export default __webpack_public_path__ + "static/media/expose3.725a5b71.png";